import React from "react";
import {Form, Input, Radio, Switch, InputNumber, Select, Upload, Icon, Modal, Card, Row, Col, Button} from 'antd';
import NHFormItem from '../../common/NHFormItem';
import NHFetch from '../../../utils/NHFetch';
import {createUuid} from '../../../utils/NHCore';
import NHSelect from '../../common/NHSelect/index'
import css from './index.css';
const FormItem = Form.Item;

const baseUrlPath = "/fwwgl/shwpgl"; //服务网管理模块路径

/**
 * 报到流程查看表单
 * @date 2018-03-02 14:00
 * Version: 1.0
 */
class ViewForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            statusList:this.props.statusList,
        }
    }


    render() {

        const initFormData = this.props.initFormData;
        return (
            <div>
                <Card title="基础信息" style={{marginBottom:'24px'}}>
                    <Row style={{marginBottom: '24px'}}>
                        <Col span={18}>步骤名称：{initFormData.BZMC}</Col>
                    </Row>
                    <Row style={{marginBottom: '24px'}}>
                        <Col span={18}>步骤说明：{initFormData.BZSM}</Col>
                    </Row>
                    <Row style={{marginBottom: '24px'}}>
                        <Col span={18}>排序号：{initFormData.PXH}</Col>
                    </Row>
                    <Row style={{marginBottom: '24px'}}>
                        <Col span={18}>状态：{initFormData.ZTM=='1'?this.state.statusList[1]:this.state.statusList[0]}</Col>
                    </Row>
                </Card>
                <Card title="步骤图片" style={{marginBottom:'24px'}}>
                    <Row gutter={16}>
                        <div>
                            {this.props.initFormData.BZTP ? <img src={"api/docrepo/download?attachmentId="+this.props.initFormData.BZTP} alt="avatar" /> : <div>未上传图片</div>}
                        </div>
                    </Row>
                </Card>
            </div>
        );
    }
}

export default ViewForm;


// WEBPACK FOOTER //
// ./components/fwwgl/bdlc/ViewForm.js